import { EMAIL_SEARCH_REGEXP } from 'features/common/utils/email'
import { User } from 'features/users/types'
import { CommentUserInfo } from '../types'

export const MENTION_REGEXP = new RegExp(`@${EMAIL_SEARCH_REGEXP.source}`)

const ALL_MENTION_REGEXP = new RegExp(MENTION_REGEXP.source, 'g')

export const getMentions = (content: string, users: User[]): CommentUserInfo[] => {
  const mentionMatches = content.matchAll(ALL_MENTION_REGEXP)
  if (!mentionMatches) return []

  return [...mentionMatches]
    .map((match) => {
      const email = match[0].slice(1)
      const user = users.find((user) => user.email === email)
      if (!user) return null
      return {
        id: user?.user_id,
        email: user?.email
      }
    })
    .filter(Boolean) as CommentUserInfo[]
}

export const getMentionedUserIds = (content: string, users: User[]): string[] => {
  return getMentions(content, users)
    .map((mention) => mention?.id)
    .filter(Boolean)
}
